import SegmentationGroupTable from './SegmentationGroupTable';
import SegmentationGroupTableExpanded from './SegmentationGroupTableExpanded';

export { SegmentationGroupTable, SegmentationGroupTableExpanded };
